import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import VueRouter from 'vue-router'
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';
// import './util/rem';
Vue.prototype.$ElementUI = ElementUI    //全局注册，使用方法为:this.$axios
Vue.prototype.$axios = axios    //全局注册，使用方法为:this.$axios

import VueCookies from 'vue-cookies';
Vue.use(VueCookies)


import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)　　

import http from '../common/http.js';
Vue.prototype.$http = http    //全局注册

import utis from '../common/utis.js';
Vue.prototype.$utis = utis    //全局注册


import MetaInfo from 'vue-meta-info';
Vue.use(MetaInfo);


import VueClipboard from 'vue-clipboard2'
Vue.use( VueClipboard )

Vue.prototype.$imgUrl = 'http://www.silubei.com/'; 


// / 引入路由
import router from "./router.js"    // import router 的router 一定要小写， 不要写成Router, 否则报 can't match的报错
Vue.config.productionTip = false
Vue.use(VueRouter);
Vue.use(ElementUI);
new Vue({
  render: h => h(App),
   router,  // 注入到根实例中
}).$mount('#app')



// 正常格式的日期时间
Vue.filter('format_date', function(time) {
	const dateTime = new Date(time * 1000);
	const YY = dateTime.getFullYear();
	const MM =
		dateTime.getMonth() + 1 < 10 ?
		'0' + (dateTime.getMonth() + 1) :
		dateTime.getMonth() + 1;
	const D =
		dateTime.getDate() < 10 ? '0' + dateTime.getDate() : dateTime.getDate();
	const hh =
		dateTime.getHours() < 10 ?
		'0' + dateTime.getHours() :
		dateTime.getHours();
	const mm =
		dateTime.getMinutes() < 10 ?
		'0' + dateTime.getMinutes() :
		dateTime.getMinutes();
	const ss =
		dateTime.getSeconds() < 10 ?
		'0' + dateTime.getSeconds() :
		dateTime.getSeconds();
	return `${YY}-${MM}-${D} ${hh}:${mm}`
});

//图片转换
Vue.filter('Ximgurl', function(img) {
	var url = '';
	
	if(img){
		if(img.indexOf('shudo.oss-cn-beijing.aliyuncs.com') ==-1){
			url  = 'http://shudo.oss-cn-beijing.aliyuncs.com';
		}
	}
	
	
	return url+img
});

//图片转换
Vue.filter('Ximgurl1', function(img) {
	var url  = 'http://www.silubei.com/';
	return url+img
});
Vue.filter('slice', function(str) {

	return str.slice(0,10);
});

